module.exports = __webpack_public_path__ + "static/media/20ECE3.e63655c8.jpg";